import { render, staticRenderFns } from "./BudgetTableBox.vue?vue&type=template&id=efa55920&"
import script from "./BudgetTableBox.vue?vue&type=script&lang=ts&"
export * from "./BudgetTableBox.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetTableBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports